import { Form, Formik } from "formik";
import { Box, Button, Grid, CircularProgress } from "@mui/material";
import CustomGrid from "components/uiComponents/CustomGrid";
import CustomButtonGrid from "components/uiComponents/CustomButtonGrid";
import FormikControl from "components/wrapperComponents/FormikControl";
import { useEffect, useRef, useState } from "react";
import { UploadFileService } from "services/shared/UploadFileService";
import { msgTypes } from "constants/msgTypes";
import { CertificateModel } from "model/screensModels/CertificateModel";
import { CertificateSchema } from "schemas/menu/certificate/CertificateSchema";
import { UploadCertificateService } from "services/menu/uploadCertificate/UploadCertificateService";
import { UtilService } from "services/shared/UtilService";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import "./UploadCertificate.scss";
import GeneratedCertificate from "./GeneratedCertificate";
import { toPng } from 'html-to-image';

const UploadCertificate = ({ setIndex, updateRecord, setFlag }) => {
  const [initialValue, setInitialValue] = useState(new CertificateModel());
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompanyName, setSelectedCompanyName] = useState("");
  const [flags, setFlags] = useState(false);
  const [isSaveButtonEnabled, setIsSaveButtonEnabled] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedCountryMembershipType, setSelectedCountryMembershipType] = useState("");
  const reportTemplateref = useRef(null);
  const formikRef = useRef(null);

  const today = new Date();

  const month = today.getMonth() + 1;
  const year = today.getFullYear();
  const date = today.getDate();
  const time = today.getTime();
  const currentDate = month + "/" + date + "/" + year + ":" + time;

  const handleGeneratePdf = async () => {
    const input = reportTemplateref.current;
    if (!input) {
      console.error("No reference to the report template found.");
      return;
    }

    try {
      await new Promise((resolve) => setTimeout(resolve, 500));
      const canvas = await html2canvas(input, { scale: 1, useCORS: true });
      const pdfData = canvas.toDataURL("image/png");

      const pdf = new jsPDF({
        orientation: "landscape",
        unit: "px",
        format: [canvas.width, canvas.height],
      });

      pdf.addImage(pdfData, "PNG", 0, 0, canvas.width, canvas.height);
      const pdfBlob = pdf.output("blob");
      const file = new File([pdfBlob], ("Certificate_" + currentDate + ".pdf"), { type: "application/pdf" });
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        const imageurlData = await UploadFileService.getImagePath(formData);
        formikRef.current.setFieldValue('pdf', imageurlData.data.fileName);
        generateImage();
      }
    } catch (error) {
      console.error("Error generating PDF:", error);
    }
  };




  const generateImage = async () => {
    const input = reportTemplateref.current;
    if (!input) return;

    try {
      const image = await toPng(input, { cacheBust: true, quality: 1 });
      const byteString = atob(image.split(',')[1]);
      const mimeString = image.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([ab], { type: mimeString });
      const file = new File([blob], ("Certificate_" + currentDate + ".png"), { type: "image/png" });
      if (file) {
        const formData = new FormData();
        formData.append("file", file);
        const imageurlData = await UploadFileService.getImagePath(formData);
        formikRef.current.setFieldValue('image', imageurlData.data.fileName);
      }

    } catch (error) {
      console.error("Error generating image:", error);
    }
  };


  const onSubmit = async (values) => {
    await uploadCertificate(values);
  };

  useEffect(() => {
    loadCompany();
  }, []);

  useEffect(() => {
    if (updateRecord) {
      setInitialValue(updateRecord);
      setSelectedCompanyName(updateRecord.companyName)
    }
  }, [updateRecord]);

  const loadCompany = async () => {
    const res = await UtilService.getCompanyList();
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      if (res.data !== '') {
        setCompanyList(res.data);
      } else {
        setCompanyList([]);
      }
    }
  };

  const prepareRequestBody = async (values) => {
    const prepareData = new CertificateModel();

    if (initialValue.certificateId?.length > 0) {
      prepareData.certificateId = initialValue.certificateId;
    } else {
      prepareData.certificateId = values.certificateId ? values.certificateId : null;
    }
    prepareData.image = values.image ? values.image : '';
    prepareData.pdf = values.pdf ? values.pdf : '';
    prepareData.companyId = values.companyId ? values.companyId : "";
    prepareData.certificateName = values.certificateName ? values.certificateName : "";
    prepareData.expireDate = values.expireDate ? values.expireDate : "";

    return prepareData;
  };

  const uploadCertificate = async (values) => {
    const requestData = await prepareRequestBody(values);
    const res = await UploadCertificateService.uploadCertificate(requestData);
    // console.log("upload certificate", res)
    if (res.statusMsg === msgTypes.SUCCESS.msg) {
      setInitialValue(new CertificateModel());
      setFlag(false);
      formikRef.current.resetForm();
    }
  };


  const handleBack = () => {
    formikRef.current.resetForm();
    setInitialValue(new CertificateModel());
    setFlag(false);
  };

  const generatePdf = async () => {
    setFlags(true);
    setLoading(true);
    setTimeout(async () => {
      await handleGeneratePdf();
      setTimeout(() => {
        setIsSaveButtonEnabled(true);
        setLoading(false);

      }, 500);
    }, 500);
  };
  
  const handleCountryChange = (value) => {
    if (value) {
      setSelectedCompanyName(value.companyName || ""); 
      setSelectedCountryMembershipType(value.membershipType || ""); 
    } else {
      setSelectedCompanyName("");
      setSelectedCountryMembershipType("");
    }
  };
  return (
    <Formik
      enableReinitialize={true}
      initialValues={initialValue}
      validationSchema={CertificateSchema}
      onSubmit={onSubmit}
      innerRef={formikRef}

    >
      {({ isSubmitting, dirty, isValid, values }) => (
        <Form>
          <div className="container">
            <div className="row">
              <div className="col-md-4 position-relative">
                <FormikControl
                  control="autocomplete"
                  name="companyId"
                  label="Company Name"
                  placeholder="Select Company"
                  onChange={handleCountryChange}
                  options={companyList}
                  keyfield="companyName"
                  valuefield="companyId"
                  requiredField
                />
              </div>
              <div className="col-md-4 position-relative">
                <FormikControl
                  control="textfield"
                  name="certificateName"
                  label="Certificate Name"
                  placeholder="Enter Certificate Name"
                  // requiredField
                />
              </div>
              <div className="col-md-4 position-relative">
                <FormikControl
                  control="datepicker"
                  name="expireDate"
                  label="Certificate Expiry Date"
                  requiredField
                  disablePast={true}
                />
              </div>
              {flags ? (
                <>
                 
                  <div className="col-md-12">
                    <CustomButtonGrid
                      item={
                        <>
                          <FormikControl
                            control="button"
                            className="btn btn-submit"
                            color="primary"
                            label={
                              loading ? (
                                <Box display="flex" alignItems="center" justifyContent="center" width="100%">
                                  <span>Generating Pdf...</span>
                                  <CircularProgress size={20} style={{ color: "white", marginRight: 8 }} />

                                </Box>
                              ) : (
                                values.certificateId === "" ? "Upload Certificate" : "Update"
                              )
                            }
                            type="submit"
                            disabled={!isSaveButtonEnabled || !dirty || !isValid || loading}
                            style={{
                              height: "40px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: loading ? "#1976d2" : undefined,
                              color: "white",
                              padding: "0 16px"
                            }}
                          />
                          <FormikControl control='button' className="btn btn-cancel" color="warning" label="Back" type="reset" onClick={() => { setFlag(false) }} />
                        </>
                      }
                    />
                  </div>
                  <div className="col-12 mt-5 pt-3">
                    <div className="row justify-content-center">
                      <div className="col-lg-9 col-xxl-8">
                        <Box className="certificate-container">
                          <div ref={reportTemplateref}>
                          <GeneratedCertificate
  selectedCompanyName={selectedCompanyName}
  certificateName={values.certificateName}
  values={values}
  membershipType={selectedCountryMembershipType} 
/>
                          </div>
                        </Box>
                      </div>
                    </div>
            
                  </div>
                </>

              ) : (
                <div className="col-md-12 d-flex justify-content-end">
                  <CustomGrid lg={4} md={6}
                    item={
                      <Box display="flex" alignItems="center">
                        <Button
                          variant="contained"
                          className="btn btn-submit"
                          color="primary"
                          onClick={generatePdf}
                          disabled={!dirty || !isValid}
                        >
                          Generate Certificate
                        </Button>
                        &nbsp;&nbsp;
                        <Button className="btn-cancel btn"
                          onClick={handleBack}
                        >
                          Back
                        </Button>
                      </Box>
                    }
                  />
                </div>
              )}
            </div>
          </div>
        </Form>
      )}
    </Formik>
  );
};

export default UploadCertificate;
